import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import styles from "./highcharts-chart-container.less";

type HighchartsChartContainerProps = {
    options: Highcharts.Options
};

export const HighchartsChartContainer = (props: HighchartsChartContainerProps) => {
    const { options } = props;

    return (
        <div className={styles.highchartsChartContainer}>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
        </div>
    );
};